export default __webpack_public_path__ + "static/media/elnos.696ccebd.png";